<template>
  <a-button type="primary" @click="onClick">{{ $t('install.extension') }}</a-button>
</template>

<script>
import { install } from '@/services/extension';

export default {
  methods: {
    onClick() {
      install();
      window.fbq('trackCustom', 'ClickExtensionInstall');
    },
  },
};
</script>
